import { faSpa, faCirclePlay, faShareNodes, faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import useAuth from '../../hooks/useAuth'
import moment from 'moment'
import axios from 'axios'
import defaultIcon from '../../img/default-file.png'
import pdfIcon from '../../img/pdf-icon.png'
import csvIcon from '../../img/csv-icon.png'

import DependantServicesGrid from '../../components/DependantServicesGrid'
import EditAppointment from '../../components/EditAppointmentSlideout'
import ViewService from '../../components/ViewServiceSlideout'
import OnboardingComplete from './Partials/OnboardingComplete'
import NextAppointment from '../../components/NextAppointment'
import ServicesGrid from '../../components/ServicesGrid'
import MainTitle from '../../components/MainTitle'
import Onboarding from './Onboarding'


function Dashboard() {
  const axiosPrivate = useAxiosPrivate()
  const { auth } = useAuth()

  const [showCompletedOnboardingModal, setShowCompleteOnboardingModal] = useState(false);
  const [showIncompleteProfileModal, setShowIncompleteProfileModal] = useState(false);
  const [showOnboardingModal, setShowOnboardingModal] = useState(false);
  const [copiedWebinarId, setCopiedWebinarId] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [nextAppointment, setNextAppointment] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [resources, setResources] = useState([]);
  const [webinars, setWebinars] = useState([]);
  const [open, setOpen] = useState(false);
  const [searchWebinars, setSearchWebinars] = useState("");
  const navigate = useNavigate();
  const getGreeting = () => {
    const currentHour = new Date().getHours()
    if (currentHour < 12) {
      return 'Good Morning'
    } else if (currentHour < 18) {
      return 'Good Afternoon'
    } else {
      return 'Good Evening'
    }
  }

  useEffect(() => {
    // fetchResources()
    fetchWebinars()
  }, [])

  useEffect(() => {
    if (auth?.user) {
      const complete = isProfileComplete()
      if (!complete) {
        setShowIncompleteProfileModal(true)
        setShowOnboardingModal(false)
      }
    }
  }, [auth?.user])

  const filteredWebinars = webinars.filter((webinar) =>
    webinar?.title?.rendered?.toLowerCase().includes(searchWebinars.toLowerCase())
  );

  const formatDate = (date) => {
    if (!date) return "";
    const year = parseInt(date.substring(0, 4));
    const month = parseInt(date.substring(4, 6)) - 1; // month is 0-indexed
    const day = parseInt(date.substring(6, 8));
  
    return new Date(year, month, day).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };



  const isProfileComplete = () => {
    return auth?.user?.onboarding_complete === 1 ? true : false
  }

  const fetchResources = async () => {
    try {
      const response = await axiosPrivate.get('/resources')
      setResources(response.data.result)
    } catch (error) {
      console.error('Error fetching resources:', error)
    }
  }


  const fetchWebinars = async () => {
    try {
      const response = await axios.get(
        'https://schooladvice.co.uk/wp-json/wp/v2/webinar?per_page=3'
      )
      const webinars = response.data
      setWebinars(webinars)
    } catch (error) {
      console.error('Error fetching webinars:', error)
    }
  }

  const viewServiceClicked = (service) => {
    setSelectedService(service)
    setOpen(true)
  }

  const editAppointmentClicked = () => {
    const complete = isProfileComplete();

    if (!complete) {
      setShowIncompleteProfileModal(true);
      return;
    }

    navigate(`/referral/${nextAppointment.booking_id}`, {
      state: {
        booking: nextAppointment.booking_id,
      },
    });
  };

  const copyToClipboard = (webinar) => {
    navigator.clipboard.writeText(webinar.link)
    setCopiedWebinarId(webinar.id)
    setTimeout(() => setCopiedWebinarId(null), 2000)
  }

  const goToWebinar = (link) => {
    window.open(link, '_blank')
  }

  const getImageForExtension = (name, path) => {
    const ext = path.split('.').pop().toLowerCase()
    if (ext === 'pdf') return pdfIcon
    // if (ext === 'doc' || ext === 'docx') return wordIcon
    if (ext === 'xls' || ext === 'xlsx') return csvIcon
    return defaultIcon
  }

  return (
    <section className="">
      <MainTitle title={`${getGreeting()}, ${auth?.user?.name}`} status links />
      {showIncompleteProfileModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-[3px] z-50 flex items-center justify-center">
          <div className="bg-white rounded-2xl p-8 shadow-2xl w-full max-w-xl border border-[#e0d0f7] relative animate-fade-in">
            <div className="flex flex-col items-center">
              <div className="bg-[#866393] rounded-full p-4 mb-4 shadow-lg">
                <FontAwesomeIcon icon={faSpa} className="text-white text-3xl" />
              </div>
              <h2 className="text-3xl font-bold text-[#41264B] mb-6 text-center">
                Welcome to School Wellbeing!
              </h2>
              <p className="text-base text-[#6b4c7c] mb-6 text-center">
                We're excited to have you here. To get started and access all
                our wellbeing services, please complete your personal profile.
              </p>
              <button
                onClick={() => {
                  setShowIncompleteProfileModal(false)
                  setShowOnboardingModal(true)
                }}
                className="w-full px-6 py-3 bg-hub-primary hover:bg-hub-primary-hover text-white rounded-lg font-semibold shadow hover:from-[#6b4c7c] hover:to-[#6b7cf4] transition"
              >
                Complete My Profile
              </button>
            </div>
          </div>
        </div>
      )}
      {showCompletedOnboardingModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-[3px] z-50 flex items-center justify-center">
          <div className="bg-white rounded-2xl p-8 shadow-2xl w-full max-w-xl border border-[#e0d0f7] relative animate-fade-in">
            <div className="flex flex-col items-center py-8">
              <OnboardingComplete dependant={false} />
              <button
                onClick={() => {
                  setShowCompleteOnboardingModal(false)
                  window.location.reload();

                }}
                className="w-full px-6 py-3 mt-4 bg-[#866393] text-white rounded-lg font-semibold shadow hover:bg-[#6b4c7c] transition"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      )}
      <>
        {showOnboardingModal && (
          <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-[3px] z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto relative">
              <Onboarding
                setShowOnboardingCompletedModal={setShowCompleteOnboardingModal}
                setShowOnboardingModal={setShowOnboardingModal}
                dependant={false}
              />
            </div>
          </div>
        )}
      </>
      <div className="col-span-1 w-full">
        <div className="mb-6 pb-6 border-b border-b-[#DDCCDF]">
          <NextAppointment />
        </div>

        {/* Wellbeing Services */}
        <div className="">
          <h2 className="text-xl font-semibold">Staff Wellbeing Services</h2>
          <p className="text-sm text-gray-600 mb-4">
            Select one of the services below to find out more.
          </p>

          {auth?.user && (
            <>
              {!!auth?.user?.parent_id ? (
                <DependantServicesGrid onViewService={viewServiceClicked} />
              ) : (
                <ServicesGrid onViewService={viewServiceClicked} />
              )}
            </>
          )}
        </div>

        {/* Wellbeing Resources */}
        <div className="mt-10">
          <h2 className="text-xl font-semibold">Wellbeing Resouces</h2>
          <p className="text-sm text-gray-600 mb-4">
            Take a look at some of our included resources
          </p>
        </div>

        <div className="text-[#41264B]">
          {/* Podcasts */}
          <div id="podcasts" className="mb-8">
            <div className="text-lg font-semibold pb-2">Podcasts</div>
            <iframe
              className="shadow-lg"
              id="player_iframe"
              src="https://www.buzzsprout.com/2179688?artist=&client_source=large_player&iframe=true&limit=5&referrer=https%3A%2F%2Fwww.buzzsprout.com%2F2179688%2Fpodcast%2Fembed"
              loading="lazy"
              width="100%"
              height="375"
              frameBorder="0"
              scrolling="no"
              title="School Wellbeing"
            ></iframe>
          </div>

          {/* Webinars */}
          <div id="webinars">
            <div className="text-lg font-semibold">Webinars</div>
            <input
              type="text"
              placeholder="Search webinars..."
              value={searchWebinars}
              onChange={(e) => setSearchWebinars(e.target.value)}
              className="border rounded-md p-2 w-full"
            />
            <div className="mt-6 mb-8 grid grid-cols-1 gap-5 sm:grid-cols-3">
              {filteredWebinars?.map((webinar) => (
                <div
                  key={webinar.id}
                  onClick={() => goToWebinar(webinar?.yoast_head_json?.og_url)}
                  className="flex flex-col bg-white border rounded-xl shadow-md cursor-pointer"
                >
                  <div
                    style={{
                      backgroundImage: `url(${webinar?.yoast_head_json?.og_image?.[0]?.url})`
                    }}
                    
                    className="rounded-t-lg px-4 h-20 flex items-center bg-cover bg-center"
                  >
                    <FontAwesomeIcon icon={faSpa} className="text-white h-8 w-8" />
                    <h2 className="text-white font-medium pl-4 py-2">
                      {webinar.title.rendered}
                    </h2>
                  </div>

                  <div className="text-gray-800 px-4 py-2 text-sm">
                    {webinar?.yoast_head_json?.og_description?.replace(/\[&hellip;]|\[…]/g, '')}
                   
                  </div>
                  <div className='text-gray-600 text-xs px-4 py-2 mt-auto'>
                  <p>{formatDate(webinar?.acf?.webinar_date)} </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Resources */}
          <div id="resources">
            <div className="text-lg font-semibold">Helpful Resources</div>
            <div className="my-10 grid grid-cols-1 gap-5 mt-4 sm:grid-cols-3">
              {resources.length > 0 ? (
                resources.map((resource) => (
                  <div
                    key={resource.id}
                    className="bg-white flex flex-col justify-center border rounded-xl shadow-md pl-3 pr-8 py-4"
                  >
                    <div className="text-gray-800 text-center flex items-center justify-between">
                      <img
                        src={getImageForExtension(
                          resource.resource_name,
                          resource.resource_type
                        )}
                        className="h-24"
                        alt="Resource"
                      />
                      <div>
                        <div className="text-right">
                          {resource.resource_name}
                        </div>
                        <div className="flex items-center justify-end space-x-2 pt-4">
                          <a
                            href={resource.resource_path}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-sm bg-portal-dark-purple hover:bg-nav-dark rounded-lg px-4 py-2 text-white font-medium"
                          >
                            <FontAwesomeIcon icon={faDownload} /> Download
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center text-gray-800 col-span-full">
                  No Resources Available
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ViewService open={open} setOpen={setOpen} service={selectedService} />
      {openEdit && (
        <EditAppointment
          open={openEdit}
          setOpen={setOpenEdit}
          booking={nextAppointment?.booking_id}
        />
      )}
    </section>
  )
}

export default Dashboard
